<div *ngFor="let banner of banners()" class="banner" [class]="banner.type">
  <i *ngIf="banner.icon" class="material-symbols-outlined">{{ banner.icon }}</i>
  <span>{{ banner.message }}</span>
</div>
